/* eslint-disable */

import request from '@/utils/request'

export function getSourceGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group',
    method: 'get',
    params: query
  })
}

export function addSourceGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group',
    method: 'post',
    data: query
  })
}

export function updateSourceGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group',
    method: 'put',
    data: query
  })
}
export function deleteSourceGroupApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group',
    method: 'delete',
    data: query
  })
}
